import { defineComponent as c, ref as p, computed as d, watch as b } from "vue";
import f from "./td-longtail-vue-components15.js";
import m from "./td-longtail-vue-components3.js";
const L = /* @__PURE__ */ c({
  __name: "carousel-navigation",
  props: {
    pages: { default: void 0 },
    ariaLabel: { default: "Pagination %d Seiten" },
    infinity: { type: Boolean },
    labelPrev: { default: "Vorherige Seite" },
    labelNext: { default: "Nächste Seite" },
    hidePages: { type: Boolean },
    hidePagesMobile: { type: Boolean },
    primary: { type: Boolean },
    secondary: { type: Boolean },
    buttonLabelFirst: { default: "Gehe zur ersten Seite" },
    buttonLabelLast: { default: "Gehe zur letzten Seite" },
    buttonLabel: { default: "Gehe zu Seite %d" },
    doNotScrollIntoView: { type: Boolean }
  },
  emits: ["update"],
  setup(l, { emit: a }) {
    const e = l, n = p(null), u = (o, r) => r.number === 0 ? e.buttonLabelFirst : r.number === o.length - 1 ? e.buttonLabelLast : e.buttonLabel.replace("%d", (r.number + 1).toString()), t = d(() => e.pages?.find((o) => o.active)), i = () => {
      t.value && (t.value.number - 1 < 0 ? a("update", e.pages?.length ? e.pages.length - 1 : 0) : a("update", t.value.number - 1));
    }, s = () => {
      t.value && (t.value.number + 1 > (e.pages?.length || 0) - 1 ? a("update", 0) : a("update", t.value.number + 1));
    };
    return b(
      () => e.pages,
      () => {
        e.doNotScrollIntoView || setTimeout(() => {
          n.value && n.value.querySelector(".carousel-navigation__link--active")?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
        }, 10);
      },
      { deep: !0 }
    ), { __sfc: !0, props: e, carouselNavigationElement: n, emits: a, ariaLabelForPageNumber: u, activePage: t, clickPrev: i, clickNext: s, ForwardBackwardButton: f, LinkButton: m };
  }
});
export {
  L as default
};
